import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * 複数選択チェックボックス
 *【選択候補:options:{label:string, value:string, checked:boolean}[]】
 *【チェックリスト:checkList:string[]】
 *【ラベル内容:labelContent:string】
 *【表示条件:visible:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-checkboxes-field',
  templateUrl: './checkboxes-field.html',
  styles: [`
    
  `]
})
export class CheckboxesField extends BaseWidget {
  /**
   * チェックリストの表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * チェックリストに対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 選択候補
   */
  @Input() options:{label:string, value:string, checked:boolean}[]

  /**
   * チェックリスト
   */
  @Input() checkList:string[]

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  updateChecked(event:Event, index:number):boolean {
   if (!this.options[index]['checked']) {
      this.checkList.push(this.options[index].value)
      this.options[index]['checked'] = true
    } else {
      this.options[index]['checked'] = false
      const removeIndex:number = this.checkList.indexOf(this.options[index].value)
      if (removeIndex !== -1) {
        this.checkList.splice(removeIndex, 1)
      }
    }
    const value:string[] = this.checkList.sort()
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event, index:index},
      `update by ${this.id}`,
    ))
    this.on(event, index)
    return this.options[index]['checked'] ? !this.options[index]['checked'] : this.options[index]['checked']
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/checkbox/checkboxes-field/checkboxes-field.component.ts